/* (c) Copyright 2020 Pivotal Software, Inc. All Rights Reserved. */
"use strict";

exports.__esModule = true;
exports.Header = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _flexGrids = require("../flex-grids");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Header = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(Header, _React$PureComponent);

  function Header() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = Header.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        cols = _this$props.cols,
        companyName = _this$props.companyName,
        logo = _this$props.logo,
        productName = _this$props.productName;
    return _react["default"].createElement(_flexGrids.Grid, {
      className: (0, _classnames["default"])('pui-siteframe-header', className)
    }, [logo && _react["default"].createElement(_flexGrids.FlexCol, {
      fixed: true
    }, logo), _react["default"].createElement(_flexGrids.FlexCol, {
      fixed: true,
      className: "pui-siteframe-header-title"
    }, _react["default"].createElement("h4", null, companyName, " ", productName && _react["default"].createElement("span", {
      className: "em-high"
    }, productName)))].concat(cols).filter(Boolean).map(function (col, key) {
      return _react["default"].cloneElement(col, {
        key: key
      });
    }));
  };

  return Header;
}(_react["default"].PureComponent);

exports.Header = Header;

_defineProperty(Header, "propTypes", {
  className: _propTypes["default"].string,
  cols: _propTypes["default"].array,
  companyName: _propTypes["default"].node.isRequired,
  logo: _propTypes["default"].node,
  productName: _propTypes["default"].node
});

_defineProperty(Header, "defaultProps", {
  cols: [],
  logo: null
});